export default __webpack_public_path__ + "static/media/e-cm-grey.ad8a1a7c.png";